import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('LAB_RESEARCH_ORDER_COUNT')